/**
 * Step — Blank garment inventory (BLU-661, client variant). Deep-links to the
 * Inventory page (NOT an inline embed): the operator receives / adjusts on-hand
 * stock for their blank garments so orders have something to print onto.
 * Completion is server-driven — `blankInventoryCount` (distinct blank SKUs with
 * on_hand > 0 at any location the org's stock lives at, including a junction
 * shared location) > 0. Mirrors the Step3Sync deep-link template.
 *
 * In the client flow this step is hidden by the step model when the client
 * uses the 3PL's garments (no blank stock of its own to receive).
 */
import { useTranslation } from 'react-i18next';
import { StepPane } from '../shell/StepPane';
import { DeepLinkGo, DeepLinkNote, DeepLinkStat } from './DeepLink';

interface StepBlankInventoryProps {
  count: number;
}

export function StepBlankInventory({ count }: StepBlankInventoryProps) {
  const { t } = useTranslation('onboarding');

  return (
    <StepPane
      title={t('stepBlankInventory.title')}
      description={t('stepBlankInventory.description')}
      primary={<DeepLinkGo page="inventory" />}
      summary={t('stepBlankInventory.summary', { count })}
    >
      <DeepLinkStat value={count} label={t('stepBlankInventory.count', { count })} />
      {count === 0 && <p className="mt-3 text-xs text-muted-foreground">{t('stepBlankInventory.emptyNote')}</p>}
      <DeepLinkNote page="inventory" />
    </StepPane>
  );
}
